import { Api } from 'lavva.exalushome';
import { AppLocalesService, IAppLocalesService } from 'lavva.exalushome/build/js/Services/AppLocalesService';
import { useBackdropContext } from '../../context/backdrop';

export const useSetAppLocale = () => {
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();

  const setAppLocale = async (locale: string) => {
    turnOnBackdrop();
    const appLocalesApi = Api.Get<IAppLocalesService>(AppLocalesService.ServiceName);
    const isAvailable = await appLocalesApi.IsAvailable();

    if (!isAvailable) {
      turnOffBackdrop();
      return;
    }

    const result = await appLocalesApi.SetCurrentLocalesAsync(locale);
    turnOffBackdrop();

    return result;
  };

  return {
    setAppLocale,
  };
};
